import React, { useEffect, useId, useRef, useState } from "react";
import { UncontrolledTooltip } from "reactstrap";

export const EllipsisWithTooltip = ({ text }) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const id = useId().replace(/:/g, "-");
  const textRef = useRef(null);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [text]);

  return (
    <div>
      <div
        id={id}
        ref={textRef}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          cursor: isTruncated ? "pointer" : "default",
        }}
      >
        {text}
      </div>

      {isTruncated && (
        <UncontrolledTooltip target={id} placement="top">
          {text}
        </UncontrolledTooltip>
      )}
    </div>
  );
};
